import { render, staticRenderFns } from "./device-org-ref-group.vue?vue&type=template&id=388f8b5c&scoped=true"
import script from "./device-org-ref-group.vue?vue&type=script&lang=ts"
export * from "./device-org-ref-group.vue?vue&type=script&lang=ts"
import style0 from "./device-org-ref-group.vue?vue&type=style&index=0&id=388f8b5c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388f8b5c",
  null
  
)

export default component.exports